// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__gQGVv","emails":"CreateEditClinics_emails__N6QfP","emailTagLabel":"CreateEditClinics_emailTagLabel__3y5Z6"};